var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.298,
    height: 16.81,
    viewBox: "0 0 21.298 16.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(1.393 1)",
    opacity: 0.755
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M4.851,6h14.81a1.857,1.857,0,0,1,1.851,1.851V18.959a1.857,1.857,0,0,1-1.851,1.851H4.851A1.857,1.857,0,0,1,3,18.959V7.851A1.857,1.857,0,0,1,4.851,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M21.512,9l-9.256,6.479L3,9",
    transform: "translate(-3 -7.149)",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.06543f520bd9151057ce09534021e968.svg";
export { ForwardRef as ReactComponent };